module.exports = __webpack_public_path__ + "static/media/glacier.6c7abe04.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/glacier.jpg
 ** module id = 430
 ** module chunks = 0
 **/